import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatabaseService } from '../database.service';
import { firestore } from 'firebase';

@Component({
  selector: 'app-numbers',
  templateUrl: './numbers.component.html',
  styleUrls: ['./numbers.component.css']
})
export class NumbersComponent implements OnInit {

  updateNumbers = new FormGroup({
    death: new FormControl("",[Validators.required]),
    revealed: new FormControl("",[Validators.required]),
    quarantaine: new FormControl("",[Validators.required]),
    totalcases: new FormControl("",[Validators.required])
  });

  jsonData:any;

  LatestData:any;
  btnmsg="vérifier les données";
  updatedMessage:boolean=false;

  updated:boolean=false;
  constructor(private database:DatabaseService) {

  }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData(){
    this.database.getMoreInformation().subscribe((data)=>{
      this.updateNumbers.setValue({
        death:data.data().nbrDeath,
        revealed:data.data().restedHumans,
        quarantaine:data.data().quarentaine,
        totalcases:data.data().totalcases
      })
    })
  }

  updateData(e){
    this.updated=false;
    this.database.updateMoreInformation({
      nbrDeath:this.updateNumbers.value.death,
      quarentaine:this.updateNumbers.value.quarantaine,
      restedHumans:this.updateNumbers.value.revealed,
      totalcases:this.updateNumbers.value.totalcases

    }).then((data)=>{
      this.updated=true;
    }).catch((error)=>{
      alert("Quelque chose s'est mal passé essaie encore.");
    })
  }



  getJSONData(){
    try {
      this.LatestData = JSON.parse(this.jsonData.trim());
      console.log(this.LatestData);
      this.deleteAllFromAgeos();
      this.jsonData="";
    } catch (error) {
      alert("Veuillez ajouter des données GeoJson valides")
    }
  }




  
  deleteAllFromAgeos(){
    this.btnmsg="suppression des anciens points..."
    let i=0;
    this.database.getInvections().subscribe((data)=>{
    data.forEach(infection => {
      let infectionData = infection.data();
      i++;
      if (infectionData.ageos==true) {
        this.database.deleteInfection(infection.id);
        console.log(infection);
        
      }

      if (i==data.docs.length) {
        this.updateNewCases();
      }
      
    })
  })

}



updateNewCases(){

  this.btnmsg="mise à jour de nouveaux points..."
  
for (let i = 0; i < this.LatestData.features.length; i++) {
var sex;
if (this.LatestData.features[i].properties.genre==="Homme") {
  sex=1;
}else{
  sex=2
}
this.database.addNewInfection({
  userinformations: {
    fullname: "inconnue",
    sex: sex,
    age: this.LatestData.features[i].properties.age,
    phone: "inconnue",
    region: this.LatestData.features[i].properties.question_sans_titre_5,
    s1: true,
    s2: true,
    s3: true,
    s4: true,
    s5: true,
    s6: true,
    s7: true,

  },
  position: new firestore.GeoPoint(this.LatestData.features[i].geometry.coordinates[1], this.LatestData.features[i].geometry.coordinates[0]),
  stat: 2,
  addDate: new Date(this.LatestData.features[i].properties.Confirm_Date),
  ageos:true
});

}
    this.btnmsg="vérifier les données";
    this.updatedMessage=true;
}






}
